const { upgradeArray } = require('../utils')

const TTS_TYPES = upgradeArray([
  'aws:maxim', // ru-RU
  'aws:tatyana', // ru-RU
  'yandex:alena', // ru-RU female v1 neutral, good
  'yandex:filipp', // ru-RU male v1
  'yandex:jane', // ru-RU female v1 neutral, good, evil
  'yandex:omazh', // ru-RU female v1 neutral, evil
  'yandex:zahar', // ru-RU male v1 
  'yandex:ermil', // ru-RU male v1 neutral, good
  'yandex:madirus', // ru-RU male v1 neutral, good
  'yandex:lea', // de-De female v1
  'yandex:john', // en-US male v1
  'yandex:amira', // kk-KK female v1
  'yandex:madi', // kk-KK male v1
  'yandex:nigora', // uz-UZ female v1
  'yandex:oksana', // ru-RU замена на alena
  'yandex:silaerkan', // tr-TR нет замены
  'yandex:erkanyavas', // tr-TR нет замены
  'yandex:alyss', // en-US замена john
  'yandex:nick' // en-US замена john
])

const TTS_LANGUAGES = upgradeArray([ 'de-DE', 'en-US', 'kk-KK', 'ru-RU', 'tr-TR', 'uz-UZ' ])

const TTS_TYPE_TO_LANGUAGE = {
  [TTS_TYPES['yandex:lea']]: TTS_LANGUAGES['de-DE'],
  [TTS_TYPES['yandex:john']]: TTS_LANGUAGES['en-US'],
  [TTS_TYPES['yandex:amira']]: TTS_LANGUAGES['kk-KK'],
  [TTS_TYPES['yandex:madi']]: TTS_LANGUAGES['kk-KK'],
  [TTS_TYPES['yandex:alena']]: TTS_LANGUAGES['ru-RU'],
  [TTS_TYPES['yandex:filipp']]: TTS_LANGUAGES['ru-RU'],
  [TTS_TYPES['yandex:ermil']]: TTS_LANGUAGES['ru-RU'],
  [TTS_TYPES['yandex:jane']]: TTS_LANGUAGES['ru-RU'],
  [TTS_TYPES['yandex:madirus']]: TTS_LANGUAGES['ru-RU'],
  [TTS_TYPES['yandex:omazh']]: TTS_LANGUAGES['ru-RU'],
  [TTS_TYPES['yandex:zahar']]: TTS_LANGUAGES['ru-RU'],
  [TTS_TYPES['yandex:nigora']]: TTS_LANGUAGES['uz-UZ']
}

// Мэппинг из неподдерживаемых голосов в поддерживаемые
const TTS_TYPES_BC = {
  [TTS_TYPES['yandex:oksana']]: TTS_TYPES['yandex:alena'],
  [TTS_TYPES['yandex:alyss']]: TTS_TYPES['yandex:john'],
  [TTS_TYPES['yandex:nick']]: TTS_TYPES['yandex:john'],
  [TTS_TYPES['yandex:silaerkan']]: TTS_TYPES['yandex:filipp'],
  [TTS_TYPES['yandex:erkanyavas']]: TTS_TYPES['yandex:filipp']
}
const TTS_TYPES_ACTUAL = upgradeArray([
  'aws:maxim', // ru-RU
  'aws:tatyana', // ru-RU
  'yandex:alena', // ru-RU female v1 neutral, good
  'yandex:filipp', // ru-RU male v1
  'yandex:jane', // ru-RU female v1 neutral, good, evil
  'yandex:omazh', // ru-RU female v1 neutral, evil
  'yandex:zahar', // ru-RU male v1 
  'yandex:ermil', // ru-RU male v1 neutral, good
  'yandex:madirus', // ru-RU male v1 neutral, good
  'yandex:lea', // de-De female v1
  'yandex:john', // en-US male v1
  'yandex:amira', // kk-KK female v1
  'yandex:madi', // kk-KK male v1
  'yandex:nigora' // uz-UZ female v1
])

module.exports = {
  TTS_TYPES,
  TTS_LANGUAGES,
  TTS_TYPES_BC,
  TTS_TYPE_TO_LANGUAGE,
  TTS_TYPES_ACTUAL
}
